function WIaccessibleFormHandler() {
    document.querySelectorAll('.form-error').forEach(error => {
        error.setAttribute('aria-hidden', 'true');
    });

    let errorElements = document.querySelectorAll('.has-error');
    if (errorElements.length > 0) {
        errorElements.forEach(errorElement => {
            let formGroup = errorElement.closest('.form-group');
            if (formGroup) {
                let formError = formGroup.querySelector('.form-error');
                if (formError) {
                    formError.setAttribute('aria-hidden', 'false');
                }
            }
        });
    }
}
